import {KeyboardEvent, MouseEvent, PropsWithChildren, ReactNode} from "react";
import {css, cx} from "@panda/css";

import {ModalCore} from "@pg-design/modal-module";

import {useBottomSheetSwipe} from "./hooks/use_bottom_sheet_swipe";
import {
    bottomSheetMotionEnterStyle,
    bottomSheetMotionExitStyle,
    bottomSheetOverlayFadeInStyle,
    bottomSheetOverlayFadeOutStyle
} from "./styles/bottom_sheet_motion";
import {getEnterExitClass} from "./utils/get_enter_exit_class";
import {BottomSheetPanel} from "./BottomSheetPanel";

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    dataTestId?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isClosing: boolean;
    isEntering: boolean;
    onClose: () => void;
    role?: string;
    shouldCloseOnOverlayClick?: boolean;
    showDivider?: boolean;
    withSwipe?: boolean;
    zIndex: number;
}

export const BottomSheet = (props: IProps) => {
    const {
        ariaLabel,
        children,
        dataTestId,
        footer,
        header,
        isClosing,
        isEntering,
        onClose,
        role,
        shouldCloseOnOverlayClick = true,
        showDivider,
        withSwipe = true,
        zIndex
    } = props;

    const {
        isEntering: sheetIsEntering,
        sheetMotionStyle,
        swipeHandlers
    } = useBottomSheetSwipe({
        enabled: withSwipe,
        isClosing,
        isEntering,
        onDismiss: onClose
    });

    const handleModalClose = (event: MouseEvent | KeyboardEvent) => {
        event.stopPropagation();
        onClose();
    };

    const handlePanelClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return (
        <ModalCore
            closeTimeout={0}
            contentClassName={bottomSheetContentStyle}
            dataTestId={dataTestId}
            isOpen
            onModalClose={handleModalClose}
            overlayClassName={cx(
                getEnterExitClass(isClosing, isEntering, bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle),
                getEnterExitClass(isClosing, isEntering, bottomSheetOverlayFadeInStyle, bottomSheetOverlayFadeOutStyle)
            )}
            overlayStyle={{zIndex}}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            showCloseButton={false}
        >
            <BottomSheetPanel
                ariaLabel={ariaLabel}
                footer={footer}
                header={header}
                isClosing={isClosing}
                isEntering={sheetIsEntering}
                motionStyle={sheetMotionStyle}
                onClick={handlePanelClick}
                role={role}
                showDivider={showDivider}
                swipeHandlers={swipeHandlers}
            >
                {children}
            </BottomSheetPanel>
        </ModalCore>
    );
};

const bottomSheetContentStyle = css({
    position: "fixed",
    top: "auto",
    right: "1rem",
    bottom: "max(0.75rem, env(safe-area-inset-bottom, 0px))",
    left: "1rem",
    maxWidth: "100%",
    maxHeight: "90vh",
    p: 0,
    backgroundColor: "transparent",
    overflow: "visible",

    "@supports (height: 100svh)": {
        maxHeight: "90svh"
    }
});
import {KeyboardEvent, MouseEvent, PropsWithChildren, ReactNode} from "react";
import {css, cx} from "@panda/css";

import {ModalCore} from "@pg-design/modal-module";

import {useBottomSheetSwipe} from "./hooks/use_bottom_sheet_swipe";
import {
    bottomSheetMotionEnterStyle,
    bottomSheetMotionExitStyle,
    bottomSheetOverlayFadeInStyle,
    bottomSheetOverlayFadeOutStyle
} from "./styles/bottom_sheet_motion";
import {getEnterExitClass} from "./utils/get_enter_exit_class";
import {BottomSheetPanel} from "./BottomSheetPanel";

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    dataTestId?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isClosing: boolean;
    isEntering: boolean;
    onClose: () => void;
    role?: string;
    shouldCloseOnOverlayClick?: boolean;
    showDivider?: boolean;
    withSwipe?: boolean;
    zIndex: number;
}

export const BottomSheet = (props: IProps) => {
    const {
        ariaLabel,
        children,
        dataTestId,
        footer,
        header,
        isClosing,
        isEntering,
        onClose,
        role,
        shouldCloseOnOverlayClick = true,
        showDivider,
        withSwipe = true,
        zIndex
    } = props;

    const {
        isEntering: sheetIsEntering,
        sheetMotionStyle,
        swipeHandlers
    } = useBottomSheetSwipe({
        enabled: withSwipe,
        isClosing,
        isEntering,
        onDismiss: onClose
    });

    const handleModalClose = (event: MouseEvent | KeyboardEvent) => {
        event.stopPropagation();
        onClose();
    };

    const handlePanelClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return (
        <ModalCore
            closeTimeout={0}
            contentClassName={bottomSheetContentStyle}
            dataTestId={dataTestId}
            isOpen
            onModalClose={handleModalClose}
            overlayClassName={cx(
                getEnterExitClass(isClosing, isEntering, bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle),
                getEnterExitClass(isClosing, isEntering, bottomSheetOverlayFadeInStyle, bottomSheetOverlayFadeOutStyle)
            )}
            overlayStyle={{zIndex}}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            showCloseButton={false}
        >
            <BottomSheetPanel
                ariaLabel={ariaLabel}
                footer={footer}
                header={header}
                isClosing={isClosing}
                isEntering={sheetIsEntering}
                motionStyle={sheetMotionStyle}
                onClick={handlePanelClick}
                role={role}
                showDivider={showDivider}
                swipeHandlers={swipeHandlers}
            >
                {children}
            </BottomSheetPanel>
        </ModalCore>
    );
};

const bottomSheetContentStyle = css({
    position: "fixed",
    top: "auto",
    right: "1rem",
    bottom: "max(0.75rem, env(safe-area-inset-bottom, 0px))",
    left: "1rem",
    maxWidth: "100%",
    maxHeight: "90vh",
    p: 0,
    backgroundColor: "transparent",
    overflow: "visible",

    "@supports (height: 100svh)": {
        maxHeight: "90svh"
    }
});
